import { setLStorage } from '../utils/util'
export default {
    //保存公司的一些信息
    setCompanyInfo(state, payload) {
        state.companyList = payload;
        state.organizationId = payload[state.companyIndex].organizationId;
        state.companyName = payload[state.companyIndex].name;
        setLStorage("companyList", payload)
        setLStorage("organizationId", payload[state.companyIndex].organizationId)
        setLStorage("companyName", payload[state.companyIndex].name)
    },

    //保存该账号是否为业主
    setIsMaster(state, payload) {
        state.isMaster = payload;
        setLStorage("isMaster", payload)
      
    },

    //判断该用户是否为管理员
    setIsAdmin(state, payload) {
        state.isAdmin = payload;
        setLStorage("isAdmin", payload)
      
    },

    //保存userId
    setUserId(state, payload) {
        state.userId = payload;
        setLStorage("userId", payload)
    },
    //续费页面的显示
    setXfShow(state, payload) {
        state.xfShow = payload;
        setLStorage("xfShow", payload)
    },
    //等待审核页面的显示
    setAuditShow(state, payload) {
        state.auditShow = payload;
        setLStorage("auditShow", payload)
    },
    //保存用户的一些信息
    setUserInfo(state, payload) {
        state.companyLogo = payload.companyLogo;
        state.name = payload.name;
        state.roleName = payload.roleName;
        state.mobile = payload.mobile;
        state.departId = payload.departId;
        state.roleId = payload.roleId;
        setLStorage("companyLogo", payload.companyLogo);
        setLStorage("name", payload.name);
        setLStorage("roleName", payload.roleName);
        setLStorage("roleName", payload.mobile);
        setLStorage("departId", payload.departId);
        setLStorage("roleId", payload.roleId);

        // state.isAdmin=payload.isAdmin;
    },
    setCompanyName(state, payload) {
        state.companyName = payload;
        setLStorage("companyName", payload)
    },
    setCompanyIndex(state, payload) {
        state.companyIndex = payload;
        setLStorage("companyIndex", payload)
    },
    setOrganizationId(state, payload) {
        state.organizationId = payload;
        setLStorage("organizationId", payload)
    },
    getProjectList(state, payload) {
        state.projectList = payload;
        setLStorage("projectList", payload)
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js